// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA2_comp__YgpT_"};